import { Select } from "antd";
import React, { useMemo } from "react";
import { useDispatch, useSelector } from "react-redux";
import unwrapAxiosPromise from "../../util/unwrapAxiosPromise";
import { fetchWorkflow, setAnoSelecionado } from "../../store/workflow";
import styles from "./_WorkflowFilterBar.less";
import { useRouteMatch } from "react-router";

export default function WorkflowFilterBarAno() {
  const match = useRouteMatch();
  const workflowId = match.params.id;
  const dispatch = useDispatch();
  const anoSelecionado = useSelector((state) => state.workflow.anoSelecionado);

  const anos = useMemo(() => {
    const currentYear = new Date().getFullYear();
    return Array.from({ length: 10 }, (_, i) => currentYear - i);
  }, []);

  const handleChange = (ano) => {
    dispatch(setAnoSelecionado(ano ?? undefined));
    unwrapAxiosPromise(dispatch(fetchWorkflow({ workflowId, arquivamento: true, ano: ano ?? undefined })));
  };

  return (
    <Select allowClear className={styles["select"]} placeholder="Selecione o ano" value={anoSelecionado} onChange={handleChange}>
      {anos.map((ano) => (
        <Select.Option key={ano} value={ano}>
          {ano}
        </Select.Option>
      ))}
    </Select>
  );
}
